module.exports = __webpack_public_path__ + "img/9a9a7fa.jpg";